import { useCallback } from 'react';

import HistoryToolsButton from 'components/common/HistorytoolsButton';

import { useHistoryStyles } from '../styles';
import { EraserHistoryToolsEnum, EraserToolsEnum, historyTools, historyToolsNew } from '../config';

interface IHistoryToolsProps {
  onReset: () => void;
  onInvert: () => void;
  toolsNameClass: string;
  onToolSelect: (type: EraserToolsEnum) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  isDarkMode: boolean;
}

const HistoryTools = ({
  onReset,
  onInvert,
  onToolSelect,
  isLoading,
  isDisabled,
  isDarkMode,
}: IHistoryToolsProps) => {
  const classes = useHistoryStyles({
    isDarkMode,
  });

  const applyTool = useCallback(async type => {
    onToolSelect(EraserToolsEnum.ERASER);

    if (type === EraserHistoryToolsEnum.INVERT) {
      onInvert();
    }
    if (type === EraserHistoryToolsEnum.RESET) {
      onReset();
    }
  }, [onInvert, onReset, onToolSelect]);

  return (
    <div className={classes.historyTools}>
      {(!isDarkMode ? historyTools : historyToolsNew).map(({
        name,
        type,
        icon,
      }) => (
        <div key={name}>
          <HistoryToolsButton
            name={name}
            icon={icon}
            isLoading={isLoading}
            isInvertTool={type === EraserHistoryToolsEnum.INVERT}
            onClick={() => applyTool(type)}
            isDisabled={isDisabled}
            isDarkMode={isDarkMode}
          />
        </div>
      ))}
    </div>
  );
};

export default HistoryTools;
